var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",class:{'icon--block': _vm.block}},[_c('img',{staticClass:"icon__img",style:({'width': _vm.size, 'height': _vm.size}),attrs:{"src":'/assets/images/icons/' + _vm.fileName,"alt":_vm.icon}})])}
var staticRenderFns = []

export { render, staticRenderFns }